/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  z as zod
} from 'zod'

/**
 * Lists external ids for a investor entity (and optionally fund)
 */
export const externalIDsRetrieveParams = zod.object({
  "investorEntityId": zod.string()
})

/**
 * Upserts external ids for a investor entity (and optionally fund)
 */
export const externalIDsUpsertParams = zod.object({
  "investorEntityId": zod.string()
})

export const externalIDsUpsertBody = zod.object({
  "upsert_data_list": zod.array( zod.object({
  "id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"name": zod.string().min(1),"external_id_type": zod.enum(['yardi', 'investran', 'juniper_square', 'other']),"fund_id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"investor_entity_id": zod.string().min(1)
}))
})

